import React from 'react';

import { Typography } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import Modal from 'common/components/Modal';

import EmailsOnlyForm from './EmailsOnlyForm';

const EditPermissionsModal = ({ callback, isOpen, onHide }) => {
    const { t } = useTranslation();

    return (
        <Modal
            onEnter={() => {}}
            onHide={onHide}
            show={isOpen}
            size="sm"
            title={t('Editing permissions')}
        >
            <Typography variant="body2" sx={{ mb: 2 }}>
                {t(
                    'Enter the e-mail addresses that will have permission to edit the fields',
                )}
            </Typography>
            <EmailsOnlyForm callback={callback} />
        </Modal>
    );
};

EditPermissionsModal.propTypes = {
    callback: PropTypes.func,
    isOpen: PropTypes.bool,
    onHide: PropTypes.func,
};

export default EditPermissionsModal;
